export const getSounds = (state) => state.localSettings.sounds || {};

export const getExpirySettings = (state) =>
  state.localSettings.expirySettings || {};

export const getPnlInTab = (state) => state.localSettings.pnlInTab || {};

export const getUnderlyingPriceTicker = (state) =>
  state.localSettings.underlyingPriceTicker || {};

export const getShowOrderIds = (state) =>
  state.localSettings.showOrderIds || false;

export const getLayoutLoginMarginTop = (state) =>
  state.localSettings.layoutLoginMarginTop || 0;
